import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { ICompleteEnglishIqV2Request } from './complete-english-iq-v2-request';
import type { ICompleteEnglishIqV2Response } from './complete-english-iq-v2-response';
import { completeEnglishIqV2ResponseSchema } from './complete-english-iq-v2-response';

export async function completeEnglishIqV2Api(
  body: ICompleteEnglishIqV2Request,
  options?: IRequestOptions,
): Promise<IValidatedResponse<ICompleteEnglishIqV2Response>> {
  return postRequest<ICompleteEnglishIqV2Response>({
    body,
    options,
    path: '/english-iq/complete/v2',
    schema: completeEnglishIqV2ResponseSchema,
  });
}
